module.exports = __webpack_public_path__ + "static/images/lights.bc89edf.png";